import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/_content")({
  component: ContentLayout,
})

function ContentLayout() {
  return <Outlet />
}
